import { Button, type ButtonProps } from "react-bootstrap";
import { MdEdit } from "react-icons/md";

const EditButton: TTButtonProps = ({ children, ...props }) => (
  <Button variant="secondary" {...(props as ButtonProps)}>
    <MdEdit /> {children}
  </Button>
);

export default EditButton;
